module.exports = __webpack_public_path__ + "img/swot_snap.dc3ed4d0.png";